import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from "vue";
  import { formatPrice } from "@/helpers/transformation/price";
  import { useToast, POSITION } from "vue-toastification";
  import {
    HouseDesignInterface,
    HouseWithLotsAndBuilder,
    LotTitleAndId,
  } from "@/types/HouseDesignInterface";
  import HouseFeatures from "@/components/builder/HouseFeatures.vue";
  import { LotInterface } from "@/types/LotInterface";
  import store from "@/store";
  import router from "@/router";
  import { EstateInterface } from "@/types/EstateInterface";
  import { BuilderInterface } from "@/types/BuilderInterface";
  import { BuilderQuote } from "@/types/BuilderQuote";
  import { BorrowCalculatorResult } from "@/types/BorrowCalculator";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'HouseCard',
  props: {
    house: {},
    estate: {},
    quote: {},
    result: {},
    houseDetailsView: { type: Boolean }
  },
  emits: ["onClickHouse"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emit = __emit;

  const toast = useToast();
  const lotsByHouseDesigns = ref<LotTitleAndId[]>();
  const builder = ref<BuilderInterface>();
  const visibleLots = ref<LotTitleAndId[]>([]);
  const showMore = ref(false);

  const LoanAmountString = computed(() => {
    return props.result?.LoanAmountString;
  });

  const remainingLots = computed(() => {
    if (lotsByHouseDesigns.value) {
      return lotsByHouseDesigns.value.length - visibleLots.value.length;
    }

    return 0;
  });

  const getLotsByEstateAndHouseDesign = () => {
    if (props.house && props.estate) {
      lotsByHouseDesigns.value = props.house.lots;
      visibleLots.value = props.house.lots.slice(0, 2);
      showMore.value = props.house.lots.length > 2;
    }
  };

  const getBuilderById = () => {
    if (props.house) {
      builder.value = props.house.builderId;
    }
  };

  const showMoreLots = () => {
    if (lotsByHouseDesigns.value) {
      visibleLots.value = lotsByHouseDesigns.value;
      showMore.value = false;
    }
  };

  const updateLocalStorage = () => {
    const { houseDetailsView } = props;
    const lotsCount = visibleLots.value.length;

    localStorage.setItem("deleteLotStorage", "true");
    localStorage.setItem(
      "filterFields",
      JSON.stringify(store.state.borrowCalculator.filterFields)
    );
  };

  const onClickHouseEvent = () => {
    const lot =
      visibleLots.value.length === 1 ? visibleLots.value[0] : undefined;

    emit("onClickHouse", lot?._id);
  };

  const navigateToCalculator = () => {
    const { house, estate, quote, result } = props;

    if (house && estate && quote && result) {
      if (props.houseDetailsView) {
        router.push({
          name: "BuilderHouseBorrowCalculator",
          params: {
            estateId: estate._id,
            quoteId: quote._id,
            houseId: house._id,
            loanAmount: LoanAmountString.value?.replace(/[$,]/g, ""),
          },
        });
        onClickHouseEvent();
      } else {
        const route = router.resolve({
          name: "BuilderHouseBorrowCalculator",
          params: {
            estateId: estate._id,
            quoteId: quote._id,
            houseId: house._id,
            loanAmount: LoanAmountString.value?.replace(/[$,]/g, ""),
          },
        });

        window.location.href = route.href;
      }
    }
  };

  const onViewDesign = () => {
    updateLocalStorage();
    navigateToCalculator();
  };

  watch(
    () => props.house,
    (newHouse) => {
      if (newHouse) {
        getLotsByEstateAndHouseDesign();
        getBuilderById();
      }
    },
    { immediate: true }
  );

  onMounted(() => {
    getLotsByEstateAndHouseDesign();
    getBuilderById();
  });

const __returned__ = { props, emit, toast, lotsByHouseDesigns, builder, visibleLots, showMore, LoanAmountString, remainingLots, getLotsByEstateAndHouseDesign, getBuilderById, showMoreLots, updateLocalStorage, onClickHouseEvent, navigateToCalculator, onViewDesign, computed, onMounted, ref, watch, get formatPrice() { return formatPrice }, get useToast() { return useToast }, get POSITION() { return POSITION }, get HouseDesignInterface() { return HouseDesignInterface }, get HouseWithLotsAndBuilder() { return HouseWithLotsAndBuilder }, get LotTitleAndId() { return LotTitleAndId }, HouseFeatures, get LotInterface() { return LotInterface }, get store() { return store }, get router() { return router }, get EstateInterface() { return EstateInterface }, get BuilderInterface() { return BuilderInterface }, get BuilderQuote() { return BuilderQuote }, get BorrowCalculatorResult() { return BorrowCalculatorResult } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})